export const FCD_LAYER = 'FCD_LAYER';
